export {default} from './LongTermListingDetail';



// WEBPACK FOOTER //
// ./src/pages/LongTermListingDetail/index.ts